import { sanitiseUrlForHost } from '@parcel2go/npm-p2g-app';
import { BUYAGAIN_PATH, RETURN_PATH } from '~/lib/constants';

// Cross-app redirects into the order-process (checkout) app, used by the consumer experience so that
// "Buy Again" and "Arrange Return" keep the customer in the order-process flow instead of dropping
// them into SmartSend. The order-process app resolves the order line by id; we only need to send the
// browser there. The computed URL is sanitised to the current host (same as `goToUrlFullyQualified`),
// so a misconfigured fully-qualified BUYAGAIN_PATH / RETURN_PATH can never become an open redirect.
const useOrderProcessLinks = () => {
  const goToBuyAgain = (orderLineId?: string) => {
    if (!orderLineId) {
      return;
    }
    window.location.href = sanitiseUrlForHost(
      `${BUYAGAIN_PATH}?id=${encodeURIComponent(orderLineId)}`,
      location.host,
      true
    );
  };

  const goToReturn = (orderLineId?: string) => {
    if (!orderLineId) {
      return;
    }
    window.location.href = sanitiseUrlForHost(
      `${RETURN_PATH}?id=${encodeURIComponent(orderLineId)}`,
      location.host,
      true
    );
  };

  return { goToBuyAgain, goToReturn } as const;
};

export default useOrderProcessLinks;
